document.addEventListener("DOMContentLoaded", () => {

  /* ==========================
     ROOT MENU
  ========================== */

  document.querySelectorAll(".rrr-mobile-root-details").forEach(root => {

    root.addEventListener("toggle", () => {

      if (!root.open) return;

      document.querySelectorAll(".rrr-mobile-root-details").forEach(item => {

        if (item !== root) {
          item.removeAttribute("open");
        }

      });

    });

  });
/*==========================
SLIDE PANELS
==========================*/

document.querySelectorAll(".rrr-mobile-root-summary")
.forEach(summary=>{

summary.addEventListener("click",()=>{

const drawer=document.querySelector(".menu-drawer__navigation");

drawer.classList.add("rrr-panel-open");

});

});
  /* ==========================
     COLLECTION ACCORDION
  ========================== */

  document.querySelectorAll(".rrr-collection-details").forEach(details => {

    details.addEventListener("toggle", () => {

      if (!details.open) return;

      const parent = details.closest(".rrr-collection-list");

      parent.querySelectorAll(".rrr-collection-details").forEach(item => {

        if (item !== details) {
          item.removeAttribute("open");
        }

      });

    });

  });

  /* ==========================
     CLOSE CHILDREN WHEN ROOT CLOSES
  ========================== */

  document.querySelectorAll(".rrr-mobile-root-details").forEach(root => {

    root.addEventListener("toggle", () => {

      if (root.open) return;

      root.querySelectorAll(".rrr-collection-details").forEach(item => {
        item.removeAttribute("open");
      });

    });

  });

});
document.querySelectorAll(".rrr-back-btn")
.forEach(btn=>{

btn.addEventListener("click",()=>{

const drawer=document.querySelector(".menu-drawer__navigation");

drawer.classList.remove("rrr-panel-open");

});

});